import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function IsCash(props) {
  const { order } = useContext(ConfiguratorContext)

  if (order.paymentType !== 'cash') return null

  return <>{props.children}</>
}
